import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./files.scss";
import Search from "../../components/search/Search";
import Select from "../../components/select/Select";
import Checkbox from "../../components/checkboxes/checkbox/Checkbox";
import YellowButton from "../../components/buttons/defaultButton/yellowButton/YellowButton";
import FilesTable from "../../components/filesTable/FilesTable";
import Pagination from "../../components/pagination/Pagination";
import AlertModal from "../../components/alertModal/AlertModal";
import FrameModal from "../../components/modals/frameModal/FrameModal";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/velmartAPI";
import useDebounse from "../../helpers/useDebounse";
import { ErrorHandler } from "../../helpers/ErrorHandler";

const Files = () => {
    const navigate = useNavigate();

    const [showAddPublickVersionModal, setShowAddPublickVersionModal] = useState(false);
    const [showFrameStructureModal, setShowFrameStructureModal] = useState(false);

    const [departmentId, setDepartmentId] = useState(0);
    const [designId, setDesignId] = useState(0);
    const [equipmentId, setEquipmentId] = useState(0);
    const [userId, setUserId] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedCheckBoxId, setSelectedCheckBoxId] = useState(0);
    const [searchValue, setSearchValue] = useState("");
    const [watchingIframeId, setWatchingIframeId] = useState(0);

    const debounceSearch = useDebounse(searchValue, 500);

    const departmentParam = departmentId ? "&department_id=" + departmentId : "";
    const designParam = designId ? "&design_id=" + designId : "";
    const equipmenParam = equipmentId ? "&equipment_id=" + equipmentId : "";
    const userParam = userId ? "&user_id=" + userId : "";
    const pageParams = "&page=" + currentPage;
    const searchParams = "&search=" + debounceSearch;

    const paramsCombiner = departmentParam + designParam + equipmenParam + userParam + pageParams + searchParams;

    const { data: files, refetch: refetchFiles } = useGetPageQuery("files?per_page=10" + paramsCombiner);
    const { data: equipments } = useGetPageQuery("equipments?per_page=100");
    const { data: designs } = useGetPageQuery("designs?per_page=100");
    const { data: departments } = useGetPageQuery("departments?per_page=100");
    const { data: users } = useGetPageQuery("users?per_page=100");
    const [sendForm, { error, isError }] = useSendFormMutation();

    const setIsPublickHandler = async (id, isPubclic) => {
        const formData = {
            is_public: isPubclic,
        };
        setShowAddPublickVersionModal(false);
        try {
            await sendForm({ url: "files/public/" + id, method: "PUT", body: formData }).unwrap();
        } catch (error) {
            ErrorHandler(error, navigate);
        }
        await refetchFiles();
    };

    const checkboxIsPublickHandler = (id, isPublic) => {
        if (isPublic) {
            setIsPublickHandler(id, 0);
        } else if (!isPublic) {
            setSelectedCheckBoxId(id);
            setShowAddPublickVersionModal(true);
        }
    };

    useEffect(() => {
        const refetch = async () => {
            await refetchFiles();
        };
        refetch();
    }, []);

    return (
        <>
            {files && equipments && designs && departments && users && (
                <div className="page-content__container">
                    <AlertModal
                        title={"Публічна версія"}
                        isOpen={showAddPublickVersionModal}
                        setIsOpen={setShowAddPublickVersionModal}
                        onConfirm={() => setIsPublickHandler(selectedCheckBoxId, 1)}
                    />
                    <FrameModal
                        isOpen={showFrameStructureModal}
                        setIsOpen={setShowFrameStructureModal}
                        watchingIframeId={watchingIframeId}
                    />
                    <div className="files">
                        <Search placeholder={"Пошук..."} value={searchValue} onChange={setSearchValue} />
                        <div className="files__filters">
                            <div className="files__filters-title">Фільтри</div>
                            <div className="files__filters-bar">
                                <div className="files__filters-bar-left">
                                    <div className="files__filters-bar-left-title">Сортувати по:</div>
                                    <Select
                                        width={"max-content"}
                                        title={"Елементи оформлення"}
                                        listData={designs.data}
                                        setValue={setDesignId}
                                    />
                                    <Select
                                        width={"max-content"}
                                        title={"Відділ"}
                                        listData={departments.data}
                                        setValue={setDepartmentId}
                                    />
                                    <Select
                                        width={"max-content"}
                                        title={"Обладнання"}
                                        listData={equipments.data}
                                        setValue={setEquipmentId}
                                    />
                                    <Select
                                        width={"max-content"}
                                        title={"Автор"}
                                        listData={users}
                                        setValue={setUserId}
                                    />
                                    {/* <Checkbox /> */}
                                </div>
                                <div className="files__filters-bar-right">
                                    <YellowButton
                                        text={"Створити файл  +"}
                                        padding={"12px 24px"}
                                        font={"14px"}
                                        onClick={() => navigate("create")}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="files__table-list">
                            <FilesTable
                                setShowAddPublickVersionModal={setShowAddPublickVersionModal}
                                setShowFrameStructureModal={setShowFrameStructureModal}
                                checkboxIsPublickHandler={checkboxIsPublickHandler}
                                setWatchingIframeId={setWatchingIframeId}
                                files={files}
                            />
                        </div>
                        {files.last_page > 1 && (
                            <Pagination
                                pageCount={files.last_page}
                                setCurrentPage={setCurrentPage}
                                fromValue={files.from}
                                toValue={files.to}
                                totalValue={files.total}
                            />
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default Files;
